//
import React from 'react'
//
import Info from "./profile/Info";

const Profile = () => {
    return <Info/>;
}

export default Profile;